import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getSubdomainFromUrl } from './utils'

export const resources = {
  en: {
    translation: {
      filters: {
        clearAll: 'Clear All',
        selectAll: 'Select All',
        search: 'Search',
        narrowYourSearch: 'Narrow Your Search',
        agesServed: 'Ages Served',
        community: 'Community',
        gender: 'Gender',
        neigborhood: 'Neighborhood',
        list: 'List',
        map: 'Map',
        sortBy: 'Sort By',
        bedsAvailable: 'Beds Available',
        bedsAreAvailable: 'Beds Are Available',
        youthOnly: 'Youth Only',
        youthOnlyServe: 'Serves youth 25 and younger',
        seniorOnly: 'Senior Only',
        seniorServe: 'Serves seniors 50 and older',
        under18: 'Under 18',
        youthOnlyUp: 'Youth Only (Up to 25)',
        adultsOnlyUp: 'Adults (18 years and older)',
        seniorsOnlyUp: 'Senior only (55 years and older)',
        open: 'Open',
        closed: 'Closed',
        callForHours: 'Call for hours',
        totalResults: 'Search Complete - {{count}} entries located.',
      },
    },
  },
  es: {
    translation: {
      filters: {
        clearAll: 'Borrar todo',
        selectAll: 'Seleccionar todo',
        search: 'Búsqueda',
        narrowYourSearch: 'Limite su búsqueda',
        agesServed: 'Edades servidas',
        community: 'Comunidad',
        gender: 'Genero',
        neigborhood: 'Vecindario',
        list: 'Lista',
        map: 'Mapa',
        sortBy: 'Ordenar por',
        bedsAvailable: 'Camas disponibles',
        bedsAreAvailable: 'Camas están disponibles',
        youthOnly: 'Solo jóvenes',
        youthOnlyServe: 'Atiende a jóvenes de 25 años y menos',
        seniorOnly: 'Solo adultos mayores',
        seniorServe: 'Atiende a adultos de 50 años en adelante',
        under18: 'Abajo de 18',
        youthOnlyUp: 'Solo jóvenes (hasta los 25)',
        adultsOnlyUp: 'Adultos (18 años o más)',
        seniorsOnlyUp: 'Solo adultos mayores (55 años o más)',
        open: 'Abierto',
        closed: 'Cerrado',
        callForHours: 'Llame para obtener horarios',
        totalResults: 'Búsqueda completa: {{count}} resultados.',
      },
    },
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: getSubdomainFromUrl(window.location.href) === 'spanish' ? 'es' : 'en',
})

export default i18n
